module.exports = __webpack_public_path__ + "static/media/logo_sair.82e6464b.jpeg";